import React, { Component } from 'react';
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'

import Login from './Login'
import SignUp from './SignUp'
import ForgotPassword from './ForgotPassword'
import { Link } from 'react-router-dom'

import pootsyWhiteLogo from '../static/img/pootsy-logo-white.png'
import loginBg from '../static/img/login-bg@2x.png'

export default class Auth extends Component {
	render() {
		let { match } = this.props
		return(
			<div className="Auth">
				<img className="login-background" alt="background" src={loginBg} />
				<div className="top">
					<Link to="/"><img className="logo" alt="logo" src={pootsyWhiteLogo}/></Link>
				</div>
				<Route path={match.url + "/signin"} component={Login}/>
				<Route path={match.url + "/signup"} component={SignUp}/>
				<Route path={match.url + "/forgot-password"} component={ForgotPassword}/>
				<div className="bottom">
					©2017 All Rights Reserved. Pootsy. Privacy and Terms
				</div>
			</div>
		)
	}
}

Auth.contextTypes = { t: PropTypes.func }



// WEBPACK FOOTER //
// ./src/components/Auth.js